import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'summaryReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as summaryReportActions };
export { reducer as summaryReportReducer };
